module.exports = __webpack_public_path__ + "assets/img/question_con.725f9c4e.jpg";